import { forumId } from './forumMappers';
import { threadTarget } from './forumQuery';

export const forumHome = query => ({ name: 'ForumNext', query: query || {} });
export const sectionLink = section => ({ name: 'ForumNextSection', params: { slug: section.slug } });
export function firstUnreadLink(threadId, reading) {
  // History may already have been marked: preserve the original resolved target.
  return reading.initialPostUnread ? { ...threadLink(threadId), hash: '#topic-' + threadId }
    : reading.firstUnreadCommentId ? threadLink(threadId, { comment_id: reading.firstUnreadCommentId }) : null;
}
export function threadLink(id, target = {}) {
  const query = threadTarget(target);
  return { name: 'ForumNextThread', params: { nid: String(id) }, query,
    hash: query.comment_id ? `#comment-${query.comment_id}` : '' };
}
export function notificationLink(item) {
  const destination = threadLink(item.threadId, { comment_id: item.commentId });
  return { ...destination, query: { ...destination.query, notice: forumId(item.commentId) } };
}
export function targetFromRoute(route) {
  const query = route.query || {};
  if (query.comment_id !== undefined) return threadTarget(query);
  const hash = /^#comment-([1-9]\d*)$/.exec(route.hash || '');
  return threadTarget(hash ? { ...query, comment_id: hash[1] } : query);
}
export function pageLink(route, page) {
  const query = { ...route.query, page: String(page) };
  delete query.comment_id; delete query.position; delete query.notice;
  return { name: route.name, params: route.params, query, hash: '' };
}
export function postLink(threadId, post) {
  return post.type === 'comment' ? threadLink(threadId, { comment_id: post.id })
    : { ...threadLink(threadId, { page: 1 }), hash: `#topic-${forumId(threadId)}` };
}
